exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thumbnail[data-v-6f70ed94]{display:block;float:left;margin:3px;height:100px;width:100px;object-fit:cover}pre[data-v-6f70ed94]{font-family:Monaco;color:#fff;padding:.5rem}p[data-v-6f70ed94]{background:#4d4d4d}header[data-v-6f70ed94]{font-size:2rem;color:#fff}footer[data-v-6f70ed94]{font-size:1rem;color:#fff}.descript[data-v-6f70ed94]{font-size:1.3rem;color:#9a9a9a;margin-bottom:2rem}.subtitle[data-v-6f70ed94]{font-size:1.2rem;color:#a7a8aa;margin-bottom:1rem}.vue-green[data-v-6f70ed94]{color:#4fc08d}.iconfont[data-v-6f70ed94]{font-size:1.5rem;margin:.3rem}.gray[data-v-6f70ed94]{color:#ccc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6f70ed94","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 17
// module chunks = 0